function initializeNoteToggles() {
  const noteContainers = document.querySelectorAll('.leave_notes_container');

  noteContainers.forEach(container => {
    const noteToggle = container.querySelector('.note_toggle');
    const noteBox = container.querySelector('.leave_note_box');

    if (noteToggle && noteBox) { // Ensure elements exist
      noteToggle.addEventListener('click', () => {
        if (noteBox.style.display === 'none' || noteBox.style.display === '') {
          noteBox.style.display = 'block';
          noteToggle.textContent = '-';
        } else {
          noteBox.style.display = 'none';
          noteToggle.textContent = '+';
        }
      });
    }
  });
}


// Call on initial page load
document.addEventListener('DOMContentLoaded', initializeNoteToggles);